import {ChangeDetectorRef, Component, forwardRef, Optional} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractControl} from "../framework/abstract-control";
import {FUIFormContext} from "../../form-context/form-context";

@Component({
    selector: "fui-time-control",
    styleUrls: ["./time-control.component.scss"],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUITimeControlComponent),
            multi: true
        }],
    templateUrl: "./time-control.component.html",
    standalone: false
})
export class FUITimeControlComponent extends FUIAbstractControl {
    constructor(changeDetectorRef: ChangeDetectorRef,
                @Optional() public context: FUIFormContext){
        super(changeDetectorRef);
    }
}
